import { type SetPreferredOrganizationArgs } from '../../api/types/organizations.types';
import { setPreferredOrganization } from '../../api';
import { useAuthContext } from '../../context';
import { useMutation } from '../base';

export default function useSetPreferredOrganization() {
  const { refetchCurrentUser } = useAuthContext();
  const response = useMutation({
    mutationFn: async ({ id, context }: SetPreferredOrganizationArgs) => {
      const response = await setPreferredOrganization({ id, context });

      return response;
    },
    onSuccess: async () => {
      await refetchCurrentUser();
    },
  });
  return {
    ...response,
    isLoading: response.status === 'pending',
  };
}
